import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../store/store-keys'
import { IMainViewState } from './main-view.reducers'
import cloneDeep from 'lodash/cloneDeep'
import clone from 'lodash/clone'

export const selectMainViewFeature =
    createFeatureSelector<Readonly<IMainViewState>>(StoreKeysEnum.MainViewFeature)

export const selectShowBulkOperations = createSelector(
    selectMainViewFeature,
    (data) => data.showBulkOperations
)

export const selectBulkOperationUpdate = createSelector(
    selectMainViewFeature,
    (data) => cloneDeep(data.bulkOperationUpdate)
)

export const selectNotificationsCount = createSelector(
    selectMainViewFeature,
    (data) => data.readNotificationsCount
)

export const selectUnreadNotificationsCount = createSelector(
    selectMainViewFeature,
    (data) => data.unreadNotificationsCount
)

export const selectMessages = createSelector(
    selectMainViewFeature,
    (data) => cloneDeep(data.messages)
)

export const selectCuzkPasswordValidityState = createSelector(
    selectMainViewFeature,
    (data) => clone(data.cuzkPasswordValidityState)
)

export const selectMessagesAndCuzkPasswordValidityState = createSelector(
    selectMessages,
    selectCuzkPasswordValidityState,
    (messages, cuzkPasswordValidityState) => ({messages, cuzkPasswordValidityState})
)

export const selectNotificationDetail = createSelector(
    selectMainViewFeature,
    (data) => cloneDeep(data.notificationDetail)
)

export const selectSelectedDepartment = createSelector(
    selectMainViewFeature,
    (data) => cloneDeep(data.selectedDepartment)
)

export const selectBulkOperations = createSelector(
    selectMainViewFeature,
    (data) => clone(data.bulkOperations)
)

export const selectContractBulkOperationsLoading = createSelector(
    selectMainViewFeature,
    (data) => data.contractBulkOperationsLoading
)

export const selectExistContractBulkOperation = createSelector(
    selectMainViewFeature,
    (data) => data.existContractBulkOperation
)

export const selectDepartments = createSelector(
    selectMainViewFeature,
    (data) => cloneDeep(data.departments)
)

export const selectBreadcrumbs = createSelector(
    selectMainViewFeature,
    (data) => cloneDeep(data.breadcrumbs)
)

export const selectBulkOperationsState = createSelector(
    selectBulkOperations,
    selectContractBulkOperationsLoading,
    selectExistContractBulkOperation,
    selectShowBulkOperations,
    (bulkOperations, contractBulkOperationsLoading, existContractBulkOperation, showBulkOperations) => ({
        bulkOperations,
        contractBulkOperationsLoading,
        existContractBulkOperation,
        showBulkOperations,
    })
)

export const selectHeaderComponentState = createSelector(
    selectBreadcrumbs,
    selectNotificationsCount,
    selectUnreadNotificationsCount,
    selectSelectedDepartment,
    (breadcrumbs, notificationsCount, unreadNotificationsCount, selectedDepartment) => ({
        breadcrumbs,
        notificationsCount,
        unreadNotificationsCount,
        selectedDepartment
    })
)

export const selectDepartmentState = createSelector(
    selectSelectedDepartment,
    selectDepartments,
    (selectedDepartment, departments) => ({selectedDepartment, anyDepartment: departments?.length > 0}),
)